import {
  OnlineCheckinErrorDescriptionsInterface
} from '../shared/interfaces';

export type ObjectOlciErrorDescriptionKey = keyof typeof RetrieveDescriptionByError;

export const RetrieveDescriptionByError: OnlineCheckinErrorDescriptionsInterface = {
  '8001': 'GET_CRUISE_CONTRACT_CONTENT_INVALID_BOOKING_ID',
  '8002': 'GET_CRUISE_CONTRACT_CONTENT_INVALID_GUEST_ID',
  '8003': 'GET_CRUISE_CONTRACT_CONTENT_CONTRACT_NOT_FOUND',
  '8004': 'GET_CRUISE_CONTRACT_CONTENT_RCCL_WEB_SERVICE_CALL_EXCEPTION',
  '8005': 'GET_CRUISE_CONTRACT_CONTENT_CONTRACT_WITH_EMPTY_SEGMENTS',
  '15001': 'GET_LANDING_PAGE_INFO_NO_YEARS',
  '15002': 'GET_LANDING_PAGE_INFO_NO_RESOURCE_BUNDLE',
  '18001': 'RETRIEVE_RESERVATION_EMPTY_BOOKING_ID_FROM_ESL',
  '18002': 'RETRIEVE_RESERVATION_COULD_NOT_OBTAIN_SAILING_DATE',
  '18003': 'RETRIEVE_RESERVATION_PAST_SAILING',
  '18004': 'RETRIEVE_RESERVATION_CRUISE_CHECKIN_IS_CLOSED',
  '18005': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_CSE0098_BOOKING_LOCKED',
  '18006': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_BKNG0017_INPUT_DOES_NOT_MATCH',
  '18007': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_CSF0293_INVALID_BOOKING_ID',
  '18008': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_EMBK1035',
  '18009': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_EMBK1038',
  '18010': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_ERR0186',
  '18011': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_ERR2829',
  '18012': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_EMBK1040',
  '18013': 'RETRIEVE_RESERVATION_ESL_ERROR_KEY_UNKNOWN',
  '18014': 'RETRIEVE_RESERVATION_ESL_EXCEPTION_RCCL',
  '18015': 'RETRIEVE_RESERVATION_ESL_EXCEPTION_SERVICE',
  '18016': 'RETRIEVE_RESERVATION_ESL_EXCEPTION_OTHER',
  '30001': 'GET_GUEST_CRUISE_HISTORY_DETAILS_RCCL_ERROR',
  '30002': 'GET_GUEST_CRUISE_HISTORY_DETAILS_UNKNOWN_ERROR',
  '31001': 'SAVE_PASSENGER_SURVEY_RCCL_ERROR',
  '31002': 'SAVE_PASSENGER_SURVEY_UNKNOWN_ERROR',
  '34001': 'GET_EXPENSE_ACCOUNT_PAGE_DATA_UNEXPECTED',
  '34002': 'GET_EXPENSE_ACCOUNT_PAGE_NULL_BOOKING',
  '34003': 'GET_EXPENSE_ACCOUNT_PAGE_NO_GUESTS',
  '35001': 'CREATE_ONBOARD_PAYMENT_WRONG_CC_TOKEN',
  '35002': 'CREATE_UPDATE_ONBOARD_PAYMENT_INVALID_CREDIT_CARD',
  '36001': 'UPDATE_ONBOARD_PAYMENT_WRONG_CC_TOKEN',
  '37001': 'DELETE_ONBOARD_PAYMENT_INVALID_BOOKING',
  '40001': 'VALIDATE_LOYALTY_NUMBER_EMPTY_DATA',
  '40002': 'VALIDATE_LOYALTY_NUMBER_DATA_DOES_NOT_MATCH',
  '40003': 'VALIDATE_LOYALTY_NUMBER_ESL_SERVICE_EXCEPTION',
  '54001': 'SAVE_PERSONAL_DETAILS_INVALID_INPUT_BINDING',
  '54002': 'SAVE_PERSONAL_DETAILS_EMPTY_GUEST_INFORMATION',
  '54003': 'SAVE_PERSONAL_DETAILS_ESL_CAN_NOT_UPDATE',
  '54004': 'SAVE_PERSONAL_DETAILS_INVALID_LOYALTY',
  '76001': 'GET_ARRIVAL_TIME_UNEXPECTED',
  '76002': 'GET_ARRIVAL_TIME_ESL_SERVICE_EXCEPTION',
  '76003': 'GET_ARRIVAL_TIME_INVALID_BINDING_RESULT',
  '76004': 'GET_ARRIVAL_TIME_NULL_LIST',
  '76005': 'GET_ARRIVAL_TIME_NULL_ELEMENT',
  '97001': 'RETRIEVE_BOARDING_PASS_SUMMARY_V2_BAD_BOOKING',
  '104001': 'RETRIEVE_GUEST_ACCOUNT_PROFILE_BOOKINGS',
}
